const clamp = ({ min = -Infinity, max }) => (value) =>
  value < min ? min : value > max ? max : value;

export default clamp;
